export default function TrustBadges() {
  const badges = [
    {
      icon: 'ri-book-open-line',
      title: 'Complete Spreadsheet Knowledge',
      description: 'Learn features, templates, use cases, and advanced techniques for the Vigorbuy Spreadsheet platform.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20workspace%20with%20open%20notebook%20and%20mechanical%20pencil%2C%20warm%20morning%20sunlight%20streaming%20through%20window%20creating%20soft%20shadows%2C%20minimalist%20office%20setting%20with%20small%20ceramic%20plant%20pot%20and%20white%20coffee%20cup%2C%20organized%20peaceful%20study%20environment%2C%20warm%20beige%20cream%20and%20soft%20olive%20tones%2C%20Scandinavian%20interior%20photography&width=600&height=320&seq=trust-badge-knowledge-v2&orientation=landscape',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Practical Templates',
      description: 'Find business, inventory, finance, and productivity spreadsheet solutions tailored to your needs.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20documents%20folders%20and%20paper%20templates%20arranged%20on%20light%20wooden%20desk%20surface%20in%20clean%20rows%2C%20professional%20workspace%20with%20laptop%20partially%20visible%20in%20background%2C%20soft%20natural%20daylight%2C%20orderly%20systematic%20layout%2C%20warm%20amber%20cream%20and%20beige%20tones%2C%20organized%20office%20photography&width=600&height=320&seq=trust-badge-templates-v2&orientation=landscape',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Detailed Comparisons',
      description: 'Compare Vigorbuy Spreadsheet with other spreadsheet platforms to make informed decisions.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Two%20similar%20elegant%20objects%20displayed%20side%20by%20side%20on%20clean%20light%20wooden%20surface%20for%20comparison%2C%20minimalist%20product%20photography%20aesthetic%2C%20soft%20warm%20natural%20window%20light%20creating%20gentle%20shadows%2C%20retail%20display%20concept%2C%20warm%20cream%20beige%20and%20soft%20terracotta%20tones%2C%20balanced%20symmetrical%20composition&width=600&height=320&seq=trust-badge-comparisons-v2&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Security First',
      description: 'Understand privacy, safety, and secure spreadsheet usage best practices for peace of mind.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20elegant%20modern%20brass%20padlock%20resting%20on%20warm%20light%20wooden%20surface%2C%20minimalist%20security%20concept%20photography%2C%20soft%20warm%20natural%20lighting%20from%20window%2C%20professional%20corporate%20feel%2C%20rich%20warm%20earth%20tones%20cream%20and%20muted%20gold%2C%20shallow%20depth%20of%20field%20focused%20on%20lock%20mechanism&width=600&height=320&seq=trust-badge-security-v2&orientation=landscape',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why Thousands Of Users Search For Vigorbuy Spreadsheet
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            Discover what makes Vigorbuy Spreadsheet the preferred choice for data management across industries.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {badges.map((badge) => (
            <div
              key={badge.title}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-300 transition-all duration-300 group cursor-default"
            >
              <div className="relative w-full h-36 overflow-hidden">
                <img
                  src={badge.imageUrl}
                  alt={badge.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/80 mb-3 group-hover:bg-primary-200 transition-colors duration-300">
                  <i className={`${badge.icon} text-lg text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {badge.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {badge.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}